import { ProjectHeaderButton } from "@/containers/Project/components/ProjectHeader/styled";
import { PROJECT_STATUS } from "@/enums";
import { routes } from "@/helpers";
import { useProjectContext } from "@/providers";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faUsers } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Row } from "antd";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";

export const ProjectTeamButton = () => {
  const intl = useIntl();
  const { project } = useProjectContext();

  const [canViewProjectTeams, setCanViewProjectTeams] = useState(false);

  useEffect(() => {
    if (project?.status) {
      setCanViewProjectTeams(
        project.status === PROJECT_STATUS.project.active.id ||
          project.status === PROJECT_STATUS.project.complete.id ||
          project.status === PROJECT_STATUS.project.canceled.id
      );
    } else {
      setCanViewProjectTeams(false);
    }
  }, [project?.status]);

  return (
    <ProjectHeaderButton
      disabled={!canViewProjectTeams}
      type="text"
      data-test-id="project-team-button"
    >
      <Link
        to={routes.projects.team(project.id)}
        target="_blank"
        data-test-id="project-team-button-link"
        rel="noreferrer"
      >
        <Row justify="center" gutter={[6, 6]}>
          <FontAwesomeIcon size="xl" icon={faUsers as IconProp} />
        </Row>
        <Row justify="center">
          {intl.formatMessage({ id: "project.projectTeamButtonLabel" })}
        </Row>
      </Link>
    </ProjectHeaderButton>
  );
};
